import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors
} from '@angular/forms';

import { ApiServiceService } from '../../services/common/api-service.service';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-merchant-register',
  templateUrl: './merchant-register.component.html',
  styleUrls: ['./merchant-register.component.scss']
})
export class MerchantRegisterComponent implements OnInit {



merchantForm!: FormGroup;


categories:any[]=[];
states:any[]=[];
districts:any[]=[];
cities:any[]=[];

currentStep:number = 1;
otpSent:boolean = false;
otpVerified:boolean = false;
otp:string = '';


selectedFiles:any = {

};



constructor(

private formBuilder:FormBuilder,

private apiService:ApiServiceService

){}




phoneValidator(control: AbstractControl): ValidationErrors | null {

  const value = control.value;

  if (!value) {
    return null;
  }

  return /^[0-9]{10}$/.test(value)
    ? null
    : { invalidPhone:true };

}



pincodeValidator(control: AbstractControl): ValidationErrors | null {

  const value = control.value;

  if (!value) {
    return null;
  }

  return /^[0-9]{6}$/.test(value)
    ? null
    : { invalidPincode:true };

}



aadhaarValidator(control: AbstractControl): ValidationErrors | null {

  const value = control.value;

  if (!value) {
    return null;
  }

  return /^[0-9]{12}$/.test(value)
    ? null
    : { invalidAadhaar:true };

}



panValidator(control: AbstractControl): ValidationErrors | null {

  const value = control.value;

  if (!value) {
    return null;
  }


  return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)
    ? null
    : { invalidPan:true };

}




ngOnInit():void{


this.getCategories();
this.getStates();


this.merchantForm =
this.formBuilder.group({



business_name:[

'',

Validators.required

],



owner_name:[

'',

Validators.required

],



category:[

'',

Validators.required

],




email:[

'',

[
Validators.required,
Validators.email
]

],





phone:[
'',

[
Validators.required,
this.phoneValidator
]

],






address_line1:[

'',

Validators.required

],





area:[

'',

Validators.required

],




city:[

'',

Validators.required

],




district:[

'',

Validators.required

],




state:[

'',

Validators.required

],





pincode:[

'',

[
Validators.required,
this.pincodeValidator
]

],





years_of_experience:[

'',

Validators.required

],





business_description:[

'',

Validators.required

],





password:[

'',

[
Validators.required,
Validators.minLength(8)
]

],




confirm_password:[

'',

Validators.required

]





},

{
validators:this.passwordMatchValidator
});

this.merchantForm.get('state')?.valueChanges.subscribe(stateId => {
  if(stateId) {
    this.getDistricts(stateId);
  } else {
    this.districts = [];
    this.merchantForm.get('district')?.setValue('');
  }
});

this.merchantForm.get('district')?.valueChanges.subscribe(distId => {
  if(distId) {
    this.getCities(distId);
  } else {
    this.cities = [];
    this.merchantForm.get('city')?.setValue('');
  }
});

}






passwordMatchValidator(
control:AbstractControl
):ValidationErrors|null{


const password =
control.get('password')?.value;


const confirmPassword =
control.get('confirm_password')?.value;



if(password !== confirmPassword){

return {

passwordMismatch:true

};

}



return null;


}







nextStep(){


let fields:string[]=[];



if(this.currentStep===1){

fields=[

'business_name',
'owner_name',
'category',
'email',
'phone'

];


if(!this.otpVerified){

Swal.fire({

title:"Mobile Verification Required",

text:"Please verify OTP before continuing",

icon:"warning",

confirmButtonColor:"#a73453"

});


return;

}

}



if(this.currentStep===2){

fields=[

'address_line1',
'area',
'city',
'district',
'state',
'pincode',
'years_of_experience',
'business_description'

];

}




let isValid=true;



fields.forEach(field=>{


const control =
this.merchantForm.get(field);


control?.markAsTouched();



if(control?.invalid){

isValid=false;

}


});




if(!isValid){


Swal.fire({

title:"Incomplete",

text:"Please fill all required fields correctly",

icon:"warning",

confirmButtonColor:"#a73453"

});


return;

}




if(this.currentStep < 3){

this.currentStep++;

}



}






previousStep(){


if(this.currentStep > 1){

this.currentStep--;

}


}









onFileChange(event:any,type:string){


const file =
event.target.files[0];


if(file){


this.selectedFiles[type]=file;


}



}







sendOtp(){

  const phone = this.merchantForm.get('phone')?.value;


  const phoneControl = this.merchantForm.get('phone');


  if(!phone || phoneControl?.invalid){

    Swal.fire({
      title:"Invalid Phone Number",
      text:"Please enter valid 10 digit mobile number",
      icon:"warning"
    });

    return;
  }


  this.apiService.sendOtp(phone,'sms')
  .subscribe({

    next:(res)=>{

      this.otpSent = true;


      Swal.fire({
        title:"OTP Sent",
        text:"OTP sent to your mobile number",
        icon:"success"
      });

    },


    error:(err)=>{

      Swal.fire({
        title:"Error",
        text:"Unable to send OTP",
        icon:"error"
      });

    }


  });


}




verifyOtp(){


const phone =
this.merchantForm.get('phone')?.value;



if(!this.otp){

 Swal.fire({
  title:"OTP Required",
  text:"Enter OTP",
  icon:"warning"
 });

 return;

}



this.apiService.verifyOtp(phone,this.otp)
.subscribe({

 next:(res)=>{


  this.otpVerified=true;


  Swal.fire({
    title:"Verified",
    text:"Mobile number verified successfully",
    icon:"success"
  });


 },


 error:(err)=>{


  Swal.fire({
    title:"Invalid OTP",
    text:"Please enter correct OTP",
    icon:"error"
  });


 }


});


}

onSubmit(){

if(!this.otpVerified){

 Swal.fire({

 title:"Mobile Verification Required",

 text:"Please verify OTP before registration",

 icon:"warning"

 });

 return;

}

if(this.merchantForm.invalid){


this.merchantForm.markAllAsTouched();


Swal.fire({

title:"Incomplete",

text:"Please fill all required fields",

icon:"warning"

});


return;


}




const formData =
new FormData();




Object.keys(
this.merchantForm.value
)
.forEach(key=>{


formData.append(

key,

this.merchantForm.value[key]

);


});
formData.append(
  "otp_verified",
  this.otpVerified ? "true" : "false"
);





Object.keys(
this.selectedFiles
)
.forEach(key=>{


if(this.selectedFiles[key]){


formData.append(

key,

this.selectedFiles[key]

);


}



});







this.apiService
.merchantRegister(formData)
.subscribe({


next:(response)=>{


if(response.status==="success"){



Swal.fire({

title:"Success",

text:"Merchant registration completed. Waiting for admin approval.",

icon:"success",

confirmButtonColor:"#a73453"

});



this.merchantForm.reset();


this.currentStep = 1;

this.otpSent = false;

this.otpVerified = false;

this.otp = '';

this.selectedFiles = {};


}



},



error:(error)=>{


Swal.fire({

title:"Error",

text:"Registration failed",

icon:"error",

confirmButtonColor:"#a73453"

});


}



});





}









getCategories(){


this.apiService
.getServiceCategories()
.subscribe({



next:(res)=>{


this.categories =
res.data;


},



error:(err)=>{


console.log(err);


}



});



}

getStates() {
  this.apiService.getState().subscribe({
    next: (res) => {
      this.states = res.data;
    },
    error: (err) => console.error(err)
  });
}

getDistricts(stateId: string) {
  this.apiService.getDistrictByState(stateId).subscribe({
    next: (res) => {
      this.districts = res.data;
    },
    error: (err) => console.error(err)
  });
}

getCities(distId: string) {
  this.apiService.getCityByDistrict(distId).subscribe({
    next: (res) => {
      this.cities = res.data;
    },
    error: (err) => console.error(err)
  });
}

}
